import { instantsInterceptor, } from '@/api/index';

function bookmarkList() {
    return instantsInterceptor.get('/service/mylibrary/bookmark/list');
}

function saveFolder(newfolder) {
    return instantsInterceptor.post('/service/mylibrary/bookmark/folder/save', newfolder);
}

function deleteFolder(folder) {
    return instantsInterceptor.post('/service/mylibrary/bookmark/folder/delete', folder);
}

function deleteBookmark(bookmark) {
    return instantsInterceptor.post('/service/mylibrary/bookmark/delete', bookmark);
}

function getBookmarks(form) {
    return instantsInterceptor.post('/service/mylibrary/bookmark/page', form);
}

export { bookmarkList, saveFolder, deleteFolder, deleteBookmark, getBookmarks };